import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";
import axios from 'axios';

// const  initialState={
//     viewData:[],
//     viewLoader:true,
//     viewError:"",
// }

export const fetchRoomList = createAsyncThunk(
    'fetchrooms',
    async (viewData) => {
        let roomId = viewData.Id;
        //   console.log(viewData);

        const projectList = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/project/${roomId}/rooms`, {
            // headers: {
            //     Authorization: 'Bearer ' + window.localStorage.getItem('userToken'),
            // },
        });
        const projectListArray = await projectList.json();
        return projectListArray;
    });

// // ✏️ Update room order in Firestore
// export const updateRoomOrder = createAsyncThunk(
//   'rooms/updateRoomOrder',
//   async ({ projectId, reorderedRooms }) => {
//     try {
//       const batch = db.batch();
//       console.log("reorderedRooms", reorderedRooms);

//       reorderedRooms.forEach(({ id, order }) => {
//         const roomRef = db
//           .collection("client")
//           .doc(projectId)
//           .collection("Rooms")
//           .doc(id);

//         batch.update(roomRef, { order });
//       });

//       await batch.commit();
//       console.log("Reordered Rooms",reorderedRooms);

//       return reorderedRooms;
//     } catch (error) {
//       console.error("❌ Error updating room order:", error);
//       return rejectWithValue("Failed to update room order");
//     }
//   }
// );

export const updateRoomOrder = createAsyncThunk(
  'rooms/updateRoomOrder',
  async ({ projectId, reorderedRooms }, { rejectWithValue }) => {
    try {
      const response = await axios.post('https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateRoomOrder', {
        projectId,
        reorderedRooms,
      });

      if (response.data.success) {
        console.log("✅ Reordered Rooms:", response.data.reorderedRooms);
        return response.data.reorderedRooms;
      } else {
        return rejectWithValue("Failed to update room order (backend error)");
      }
    } catch (error) {
      console.error("❌ Error calling backend API:", error);
      return rejectWithValue("Failed to update room order");
    }
  }
);



const viewRoomReducer = createSlice({
    name: 'viewrooms',
    initialState: {
        viewData: [],
        viewLoader: true,
        viewError: "",
    },
    reducers: {},
    extraReducers: {
        [fetchRoomList.fulfilled]: (state, action) => {
            state.viewData = Array.isArray(action.payload) ? action.payload : [];
            state.viewLoader = false;
        },
        [fetchRoomList.pending]: (state, action) => {
            state.viewData = [];
            state.viewLoader = true;
        },
        [fetchRoomList.rejected]: (state, action) => {
            state.viewData = [];
            state.viewLoader = false;
            state.viewError = "refresh the page";
        },
        [updateRoomOrder.pending]: (state) => {
            state.viewLoader = true;
        },
        [updateRoomOrder.fulfilled]: (state) => {
            state.viewLoader = false;
        },
        [updateRoomOrder.rejected]: (state, action) => {
            state.viewError = 'Failed to update room order';
        },
    }
});

export default viewRoomReducer.reducer



// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { firestore as db } from "../config/Config";

// // 🔄 Fetch rooms ordered by `order` field from Firestore
// export const fetchRoomList = createAsyncThunk(
//   'fetchrooms',
//   async ({ projectId }, { rejectWithValue }) => {
//     console.log("projectId",projectId);
    
//     try {
//       const roomSnap = await db
//       .collection("client")
//       .doc(projectId)
//       .collection("Rooms")
//       .get();

      
//       console.log("projectId",roomSnap);
//       const rooms = roomSnap.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       console.log("projectId",rooms);

//       return rooms;
//     } catch (error) {
//       console.error("Error fetching rooms:", error);
//       return rejectWithValue("Failed to fetch rooms");
//     }
//   }
// );

// // ✏️ Update room order in Firestore
// export const updateRoomOrder = createAsyncThunk(
//   'rooms/updateRoomOrder',
//   async ({ projectId, reorderedRooms }, { rejectWithValue }) => {
//     try {
//       const batch = db.batch();
//       console.log("reorderedRooms", reorderedRooms);

//       reorderedRooms.forEach(({ id, order }) => {
//         const roomRef = db
//           .collection("client")
//           .doc(projectId)
//           .collection("Rooms")
//           .doc(id);

//         batch.update(roomRef, { order });
//       });

//       await batch.commit();
//       console.log("✅ Room order updated in Firestore");

//       return reorderedRooms;
//     } catch (error) {
//       console.error("❌ Error updating room order:", error);
//       return rejectWithValue("Failed to update room order");
//     }
//   }
// );


// // 📦 Slice
// const viewRoomReducer = createSlice({
//   name: 'viewrooms',
//   initialState: {
//     viewData: [],
//     viewLoader: false,
//     viewError: "",
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchRoomList.pending, (state) => {
//         state.viewLoader = true;
//         state.viewError = "";
//       })
//       .addCase(fetchRoomList.fulfilled, (state, action) => {
//         state.viewData = action.payload;
//         state.viewLoader = false;
//       })
//       .addCase(fetchRoomList.rejected, (state, action) => {
//         state.viewLoader = false;
//         state.viewError = action.payload || "Refresh the page";
//       })
//       .addCase(updateRoomOrder.pending, (state) => {
//         state.viewLoader = true;
//         state.viewError = "";
//       })
//       .addCase(updateRoomOrder.fulfilled, (state) => {
//         state.viewLoader = false;
//       })
//       .addCase(updateRoomOrder.rejected, (state, action) => {
//         state.viewLoader = false;
//         state.viewError = action.payload || "Failed to update room order";
//       });
//   }
// });

// export default viewRoomReducer.reducer;
